import { IconButton, styled } from '@project44/manifest-ds';
import { Box, styled as uistyled } from '@project44/manifest-ui-deprecated';

import { EntityEnum } from '../../definitions/enums/Entity';
import { EntityColorEnum } from '../../definitions/enums/EntityColor';
import { PANEL_WIDTH } from '../../utils/constants/PANEL_WIDTH';

export const StyledPanel = uistyled(Box)(
  ({
    expand,
    expandwidth,
  }: {
    expand: number;
    expandwidth?: number | 'auto';
  }) => ({
    background: 'white',
    borderRadius: 'medium',
    boxShadow:
      '0px 9px 12px rgba(0, 0, 0, 0.05), 0px 3px 16px rgba(0, 0, 0, 0.04), 0px 5px 6px rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    transition: 'width 0.2s linear',
    width: expand === 1 ? expandwidth || PANEL_WIDTH * 2 : PANEL_WIDTH,
  }),
);

export const PanelHeaderContent = styled('div', {
  height: '65px',
  alignItems: 'center',
  background: '$background-primary',
  borderBottom: '1px solid $border-primary',
  display: 'flex',
  flexDirection: 'row',
  fontSize: '$large',
  fontWeight: '$bold',
  padding: '$medium',
  top: 0,
  '&:before': {
    borderRadius: '1px',
    content: '" "',
    display: 'inline-block',
    height: 20,
    marginRight: '$small',
    width: '4px',
  },
  variants: {
    entityType: {
      [EntityEnum.shipment]: {
        '&:before': {
          background: EntityColorEnum[EntityEnum.shipment],
        },
      },
      [EntityEnum.order]: {
        '&:before': {
          background: EntityColorEnum[EntityEnum.order],
        },
      },
    },
  },
});

export const PanelExtraContent = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  '> *': {
    marginLeft: '$x-small',
  },
});

export const StyledIconButton = styled(IconButton, {
  width: '2rem',
  height: '2rem',
});
